/**
 * Wake-up ping — Phase 6a.4 per spec §7.2 Layer 1.
 *
 * On app mount, fire a non-blocking GET /api/health so the first real
 * calculation request finds a warm server (Render free tier sleeps after
 * ~5–10 min idle; cold-boot is 30–50 s).
 *
 * Module-level promise dedups concurrent calls. On failure, the promise is
 * reset so the next caller can retry. The function never throws — failure
 * is silent by design (next real request will surface any issue with proper
 * UX via the multi-stage spinner in Phase 6a.5).
 */

import { apiFetch } from "./client";

let warmupPromise: Promise<unknown> | null = null;

export function warmupServer(): Promise<unknown> {
  if (warmupPromise) return warmupPromise;
  warmupPromise = apiFetch("/api/health", { method: "GET" }, { timeout: 60_000 }).catch(
    () => {
      warmupPromise = null; // allow retry on next call
    },
  );
  return warmupPromise;
}
